























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { ALL_PROJECTS } from '@/queries/Project';
import { GQL_deleteProject_deleteProject_project } from '@/queries/__generated__/deleteProject';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_currentUnitProjects, GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';
import gql from 'graphql-tag';

const DELETE_PROJECT = gql`
  mutation deleteProject($id: ID!) {
    deleteProject(
      input: {
        id: $id,
      }
    ) {
      project {
        id
      }
    }
  }
`;

@Component
export default class ProjectDeleteButton extends Vue {
  @Prop() public project!: GQL_currentUnitProjects_currentUnit_projects;
  public DELETE_PROJECT = DELETE_PROJECT;

  @Emit('project-deleted')
  public removeFromCache(
    store: InMemoryCache,
    { data: { deleteProject: { project } } }: {data: {deleteProject: {project: GQL_deleteProject_deleteProject_project}} },
  ) {
    const data = (store.readQuery({ query: ALL_PROJECTS }) as GQL_currentUnitProjects);
    data.currentUnit.projects = data.currentUnit.projects.filter(c => c.id !== project.id);
    store.writeQuery({ query: ALL_PROJECTS, data });
  }

  public confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: `${this.project.code} - ${this.project.name}` }),
      onConfirm: confirmMutation,
    });
  }
}
